module.exports = __webpack_public_path__ + "static/og_image-a8d4194d221d2521d94421ba9f7c31ac.png";